export const CHANGE_THEME_TO_DARK = 'CHANGE_THEME_TO_DARK';
export const CHANGE_THEME_TO_LIGHT = 'CHANGE_THEME_TO_LIGHT';
export const CHANGE_THEME = 'CHANGE_THEME';

export function changeThemeToPurple() {
    return {
        type: CHANGE_THEME_TO_DARK,
    };
}
export function changeThemeToGreen() {
    return {
        type: CHANGE_THEME_TO_LIGHT,
    };
}
export function changeTheme(theme) {
    return {
        type: CHANGE_THEME,
        theme,
    };
}
